import { SERVICE_CONFIG } from '../constants/accountService';
import { isDemoMode } from '../tradingMode';
import { computed } from 'vue';
/**
 * 계좌 서비스 폼 검증 Composable
 *
 * 서비스별 필수 필드 검증 및 금액 검증을 담당합니다.
 * SERVICE_CONFIG의 requiredFields를 활용하여 중복 코드를 제거합니다.
 *
 * @param menuState 현재 선택된 서비스 타입
 * @param serviceState 현재 선택된 서비스의 데이터 (단일 객체)
 * @param refs 각 서비스 컴포넌트의 ref 객체
 * @returns 검증 관련 computed 값들
 */
export const useServiceValidation = (menuState, serviceState, refs) => {
    /**
     * 필수 필드가 모두 채워졌는지 검증
     * SERVICE_CONFIG의 requiredFields를 기반으로 동적으로 검증
     * 입금 서비스의 경우 모의 상태에 따라 필수 필드를 동적으로 결정
     */
    const hasRequiredFields = computed(() => {
        if (!menuState.value || !serviceState.value)
            return false;
        const config = SERVICE_CONFIG[menuState.value];
        const currentData = serviceState.value;
        // 입금 서비스의 경우 모의 상태에 따라 필수 필드를 동적으로 결정
        let requiredFields;
        if (menuState.value === 'deposit') {
            // 모의 상태일 때와 실거래 상태일 때 다른 필수 필드 사용
            requiredFields = isDemoMode()
                ? ['depositAccount', 'accountPassword']
                : ['depositAccount', 'accountPassword', 'bankCode', 'transferStatement'];
        }
        else {
            requiredFields = config.requiredFields;
        }
        // 필수 필드를 순회하며 검증
        return requiredFields.every((fieldName) => {
            const value = currentData[fieldName];
            // null 체크 (파일 업로드)
            if (String(fieldName) === 'transferStatement') {
                return value !== null;
            }
            // 문자열 체크
            if (typeof value === 'string') {
                return value.trim() !== '';
            }
            return false;
        });
    });
    /**
     * 금액 검증
     * 각 서비스 컴포넌트에서 expose된 금액 유효성 검증 값 사용
     */
    const isAmountValid = computed(() => {
        if (!menuState.value)
            return false;
        switch (menuState.value) {
            case 'withdraw':
                return refs.applyWithdrawalRef.value?.isWithdrawalAmountValid ?? false;
            case 'transfer':
                return refs.transferRef.value?.isTransferAmountValid ?? false;
            case 'deposit':
                return refs.depositRef.value?.isDepositAmountValid ?? false;
            default:
                return false;
        }
    });
    /**
     * 전체 폼 검증
     * 필수 필드와 금액이 모두 유효할 때만 true
     */
    const isFormValid = computed(() => {
        return hasRequiredFields.value && isAmountValid.value;
    });
    return {
        hasRequiredFields,
        isAmountValid,
        isFormValid,
    };
};
//# sourceMappingURL=useServiceValidation.js.map